import { render, staticRenderFns } from "./TMBTable.vue?vue&type=template&id=ce877142&scoped=true"
import script from "./TMBTable.vue?vue&type=script&lang=js"
export * from "./TMBTable.vue?vue&type=script&lang=js"
import style0 from "./TMBTable.vue?vue&type=style&index=0&id=ce877142&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce877142",
  null
  
)

export default component.exports